module.exports = __webpack_public_path__ + "static/img/java.e5433e60.png";